import React from 'react';
import './contact-info-sec7.css'

const Contactinfo = (props) => {
    return ( 
        <article className='main-card-contact-sec7'>
                <img className='img-contact' src={props.img} alt={props.alt}></img>
                <article className='colum-cont-contact'>
                    <h2 className='name-cont'>{props.tite}</h2>
                    <h2 className='sentence-sec7'>{props.sent}</h2>
                </article>
        </article>
     );
}
 
export default Contactinfo;